import { useTranslation } from 'react-i18next'

import { DataItemSublistItem } from './types'
import { unLinkDataItem } from './utils'
import { Button } from '@/Atomic/Molecules/Button'
import { SublistItem, SublistItemContent } from '@/Atomic/Templates/Sublist'
import { useUndoableAction } from '@/hooks/useUndoableAction'

interface SublistBodyProps {
  items: DataItemSublistItem[]
  flashItemId?: string | null
  onOpenDrawer?: (item: DataItemSublistItem) => void
}

export const SublistBody: React.FC<SublistBodyProps> = ({
  items,
  flashItemId,
  onOpenDrawer,
}) => {
  const { t } = useTranslation()
  const { isHidden, run } = useUndoableAction()

  return items.flatMap((item) => {
    if (item.connection && isHidden(item.connection.id())) {
      return []
    }

    const unlinkButton = item.connection && (
      <Button
        variant="icon"
        icon="cross"
        tooltip={t('common.remove')}
        onClick={() => {
          const relationId = item.connection?.id()
          if (!relationId) return

          run({
            id: relationId,
            onAction: ({ onError, onUndo }) =>
              unLinkDataItem({
                relationDataItem: item.connection,
                removedListItem: item.dataItem,
                onError,
                onUndo,
              }),
          })
        }}
      />
    )

    return (
      <SublistItem key={item.id} flash={item.id === flashItemId}>
        <SublistItemContent
          avatar={item.image}
          avatarIcon={item.avatarIcon}
          fallbackInitials={item.initials}
          initialsColorSeed={item.id}
          title={item.title}
          subtitle={item.subtitle}
          badgeValue={item.badgeValue}
          badgeVariant={item.badgeVariant}
          secondaryBadgeValue={item.secondaryBadgeValue}
          secondaryBadgeVariant={item.secondaryBadgeVariant}
          dataItem={onOpenDrawer ? undefined : item.dataItem}
          onClick={onOpenDrawer ? () => onOpenDrawer(item) : undefined}
          showButton="onHover"
          button={unlinkButton || undefined}
        />
      </SublistItem>
    )
  })
}
